<template>
    <div class="card">
        <div class="card-header bg-secondary d-flex justify-content-between" v-if="abono.asiento">
            <div>
                <span>{{ n_abono }}</span>
                {{ abono.asiento.zona_nombre }} <br>
                Fila: {{ abono.asiento.fila }} / Butaca: {{ abono.asiento.asiento }}
            </div>
            <div class="m-0 ml-auto"><Button class="button small-button" type="button" @click="$emit('borrar')">Eliminar</Button></div>
        </div>
        <div class="card-header bg-secondary" v-else>
            <span>Abono - {{ n_abono }}</span>
        </div>
        <div class="card-body">
            <label for="obtener">Obtener datos de abonado existente</label>
            <div class="input-group">
                <input name="obtener" type="text" class="form-control" placeholder="Introduce nº de abonado" v-model="buscar">
                <span class="input-group-append">
                    <Button @click.prevent="buscarAbonado()" type="button" class="btn-flat">Obtener</Button>
                </span>
            </div>
            <hr>
            <template v-if="!loading">
                <FormInput label="Nombre" :name="'nombre' + index" rules="required" v-model="abono.nombre" @change="actualizado" />
                <FormInput label="Apellidos" :name="'apellidos' + index" rules="required" v-model="abono.apellidos" @change="actualizado" />
                
                <div class="form-group">
                    <label for="genero">Género</label>
                    <ValidationProvider :name="'generos' + index" rules="required" v-slot="{ errors }">
                        <multiselect
                            id="genero"
                            :class="(errors[0] ? 'is-invalid' : '')"
                            v-model="abono.genero_id"
                            :placeholder="$t('formularios.genero')"
                            track-by="id"
                            v-on:change="actualizado"
                            :options="generos.map(genero => genero.id)" 
                            :custom-label="opt => generos.find(x => x.id == opt).name">
                        ></multiselect>
                        <span v-if="errors[0]" class="error invalid-feedback" style="display: block;">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>

                <FormInput label="Dni" :name="'dni' + index" rules="required" v-model="abono.dni" @change="actualizado" />
                <FormInput label="Fecha de nacimiento" type="date" :name="'fecha_nacimiento' + index" rules="required" min="1900-01-01" v-model="abono.fecha_nacimiento" @change="actualizado" />
                <FormInput label="Email" :name="'email' + index" rules="required" v-model="abono.email" @change="actualizado" />
                <FormInput label="Teléfono" :name="'telefono' + index" rules="required" v-model="abono.telefono" @change="actualizado" />
                <FormInput v-if="mostrar_iban == true" label="IBAN" :name="'iban' + index" rules="required" v-model="abono.iban" @change="actualizado" />
                <FormInput v-if="mostrar_titular_cuenta == true" label="Titular de la cuenta" :name="'titular_cuenta' + index" rules="required" v-model="abono.titular_cuenta" @change="actualizado" />

                <div class="form-group">
                    <Paises :errors="errors" v-on:selected="opt => { pais = opt; abono.pais = opt.nombre; actualizado(); }"/>
                </div>
                <div class="form-group">
                    <Provincias :errors="errors" :pais="pais.id" v-on:selected="opt => { provincia = opt; abono.provincia = opt.nombre; actualizado(); }"/>
                </div>
                <div class="form-group">
                    <Locations :provincia="provincia" :errors="errors" v-on:selected="opt => { abono.localidad = opt.nombre; actualizado(); }"/>
                </div>
                <div class="form-group">
                    <label for="domicilio">Domicilio completo</label>
                    <ValidationProvider :name="'domicilio' + index" rules="required" v-slot="{ errors }">
                        <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Domicilio" v-model="abono.domicilio" v-on:change="actualizado">
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <label for="cp">CP/ZIP CODE</label>
                    <ValidationProvider :name="'cp' + index" v-slot="{ errors }">
                        <input type="text"
                               :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                               maxlength="10"
                               minlength="5"
                               placeholder="CP/ZIP CODE"
                               v-model="abono.cp"
                               v-on:change="actualizado">
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <label for="empresa">Compañía / Actividad</label>
                    <input type="text" class="form-control" placeholder="Peña/Empresa" v-model="abono.penista" v-on:change="actualizado">
                </div>
                <div class="form-group">
                    <label for="area">Tipo de abono</label>
                    <ValidationProvider :name="'area' + index" rules="required" v-slot="{ errors }">
                        <select :disabled="manager.tipo != 1" id="tipo-abono" name="area" v-model="abono.area" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" v-on:change="actualizado">
                            <template v-for="(precio, index) in precios">
                                <option :key="index" :value="precio">
                                    <span v-if="precio.renovacion">(Renovación) - </span>
                                    {{ precio.descripcion }}
                                </option>
                            </template>
                        </select>
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <label for="precio">Precio</label>
                    <ValidationProvider :name="'precio' + index" rules="required" v-slot="{ errors }">
                        <select id="precio" name="precio" v-model="abono.precio" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" v-on:change="actualizado">
                            <template v-for="(descuento, index) in abono.area.descuentos">
                                <option :key="index" :value="descuento">
                                    {{ descuento.label_taquilla }}
                                </option>
                            </template>
                        </select>
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <label for="observaciones">Observaciones</label>
                    <textarea class="form-control" rows="3" placeholder="Observaciones..." v-model="abono.observaciones"></textarea>
                </div>
            </template>
            <template v-else>
                <LoaderComponent></LoaderComponent>
            </template>
        </div>
    </div>
</template>

<script>
    import Provincias from "../../../common/forms/Provincias";
    import Locations from "../../../common/forms/Locations";
    import Paises from "../../../common/forms/Paises";

    export default {
        props: ['abono', 'generos', 'index', 'precios', 'area', 'zona'],
        data() {
            return {
                buscar: '',
                loading: false,
                errors: [],
                provincia: null,
                pais: { id: 0 },
                mostrar_iban: this.$store.getters.getTeatro.mostrar_iban,
                mostrar_titular_cuenta: this.$store.getters.getTeatro.mostrar_titular_cuenta
            }
        },
        created() {
            if(this.$route.query.n_abonado_antiguo && this.n_abono == 1) {
                this.buscar = this.$route.query.n_abonado_antiguo;
                this.buscarAbonado();
            }
        },
        computed: {
            n_abono() {
                return this.index + 1;
            },
            manager() {
                return this.$store.getters.getFooter;
            }
        },
        mounted() {
            if(!this.abono.area) {
                this.abono.area = this.precios[0];
            }            
            this.precios.forEach((precio) => {
                if(this.zona && precio.descripcion.toUpperCase() === this.zona.name.toUpperCase()) {
                    this.abono.area = precio;
                }
            });
            this.actualizado();
        },
        methods: {
            buscarAbonado() {
                this.loading = true;

                const params = {
                    filters : {
                        n_abonado_antiguo: this.buscar,
                        n_abonado_antiguo_single: this.buscar
                    }
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.index'), params).then(res => {
                    this.$nextTick(function() {
                        this.abono.nombre = res.data.data.name;
                        this.abono.apellidos = res.data.data.surnames;
                        this.abono.dni = res.data.data.dni;
                        this.abono.es_nuevo = false;
                        this.abono.telefono = res.data.data.telefono;
                        this.abono.fecha_nacimiento = res.data.data.fecha_nacimiento;
                        this.abono.email = res.data.data.email;
                        this.abono.provincia = res.data.data.provincia;
                        this.abono.localidad = res.data.data.localidad;
                        this.abono.domicilio = res.data.data.domicilio;
                        this.abono.penista = res.data.data.penista;
                        this.abono.observaciones = res.data.data.observaciones;
                        this.abono.n_abonado_antiguo = res.data.data.n_abonado_antiguo;
                        this.abono.cp = res.data.data.cp;
                    });

                }).finally(() => this.loading = false);
            },
            actualizado() {
                this.$emit('actualizado');
            },
        },
        components: {
            Locations,
            Provincias,
            Paises
        }
    }
</script>

<style>

</style>
